const appConfig = {
    apiPrefix: 'https://tools.expressdeliverygroup.com/api',
    //apiPrefix: 'https://backend.viniabruzzesi.it/api',
    authenticatedEntryPath: '/home',
    unAuthenticatedEntryPath: '/sign-in',
    tourPath: '/',
    locale: 'en',
    enableMock: false,
}
export default appConfig
